import { captureException } from '@sentry/nextjs';

import { getUserStore } from '@/stores';

import Csrf from './Csrf';
import SendRequest from './SendRequest';

export default class CouponService {
  public static async getCoupon(id: string) {
    return await this.doRequest<null, CouponService.Response>('/api/coupons/getCoupon', id);
  }

  static async doRequest<T, R>(path: string, id: string) {
    const formBody = new FormData();
    const userStore = getUserStore();
    const csrf = userStore?.csrfToken ?? (await Csrf.getCsrf());

    formBody.append('CRAFT_CSRF_TOKEN', csrf);
    formBody.append('entryId', id);
    const headers = new Headers({
      Accept: 'application/json',
      SameSite: 'true',
    });

    try {
      return await SendRequest<T, R>({
        path,
        method: 'POST',
        headers,
        formBody,
      });
    } catch (error) {
      captureException(error);
      return null;
    }
  }
}
